import {Table, Form, Space, Flex, App, Radio } from 'antd'
import React, { useEffect, useState } from 'react'
import Copy from '../../cpn/Copy';
import ReportCheck from '../../document/report/ReportCheck';
import classes from './expenseInvoice.module.css';
import StateTag from '../../cpn/StateTag';
import Icon from '../../cpn/Icon';
import ExpenseInvoiceAdd from './ExpenseInvoiceAdd';
import ClientSelect from '../../system/client/ClientSelect';
import ExpenseCheck from '../../document/expense/ExpenseCheck';
function ExpenseInvoiceExpenseList(props) {
    const { message } = App.useApp();
    const [form] = Form.useForm();
    const [list,setList] = useState([]);   
    const [query, setQuery] = useState({
      "fy_state": '',     
  });
    useEffect(() => {
        if (props.expenseList) {
            let arr = props.expenseList.filter((item) => (item.fy_state === '2' || item.fy_state === '3' || item.fy_state === '4' || item.fy_state === '5'));      
            if(query.fy_kh_id){
              arr = arr.filter((item) => item.fy_kh_id === query.fy_kh_id);
            }      
            if(query.fy_fypdj_id==='1'){
                // 等于'1'，不过滤，不做任何处理
            }else if(query.fy_fypdj_id==='2'){
                arr = arr.filter((item) => !item.fy_fypdj_id);
            }else if(query.fy_fypdj_id==='3'){
                arr = arr.filter((item) => item.fy_fypdj_id);
            }
            arr = arr.map((item) => ({
                ...item,
                key: item.key || item.fy_id
            }));
            arr.sort((a, b) => new Date(b.fy_ctime) - new Date(a.fy_ctime));
            setList(arr);
        }
    }, [props.expenseList, query.fy_kh_id, query.fy_fypdj_id, props.yh_id])
    
    const columns = [    
        {
            title: '费用客户',
            dataIndex: 'fy_kh_name',
            width: '12%',
            key: 'fy_kh_name',         
            render: (text, record) =><ExpenseCheck
                                        type='button'
                                        fy_id={record.key} 
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        fy_bzd_id={record.fy_bzd_id}
                                        fy_price={record.fy_price}
                                        fy_content={record.fy_content}
                                        fy_date={record.fy_date}
                                        fy_date_end={record.fy_date_end}
                                        fy_bzd_name={record.fy_bzd_name}
                                        fy_bzd_danhao={record.fy_bzd_danhao}
                                        fy_type_id={record.fy_type_id}
                                        fy_type_name={record.fy_type_name}
                                        fy_kh_id={record.fy_kh_id}
                                        fy_kh_name={record.fy_kh_name}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        fy_num={record.fy_num}
                                        fy_amount={record.fy_amount}
                                        fy_state={record.fy_state}
                                        fy_bm_id={record.fy_bm_id}
                                        fy_bm_name={record.fy_bm_name}
                                        fy_khyhzh_id={record.fy_khyhzh_id}
                                        fy_khyhzh_name={record.fy_khyhzh_name}
                                        fy_image_name={record.fy_image_name}
                                        fy_image_file={record.fy_image_file}
                                        fy_ctime={record.fy_ctime}
                                        fy_uid={record.fy_uid}
                                    />
        },
        {
            title: '费用金额',
            dataIndex: 'fy_amount',
            width: '10%',
            key: 'fy_amount',   
            render: (text, record) => <span style={{color:'#3366FF'}}>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '备注',
            dataIndex: 'fy_content',
            key:'fy_content',
            render:(text) => <Copy title={text}/>
        },   
        {
            title: '团队名称',
            width: '10%', 
            dataIndex:"fy_bzd_danhao",
            key:'fy_bzd_danhao',
            render:(text,record) => {
                return <ReportCheck  dsbzd_name={record.fy_bzd_name} dsbzd_id={record.fy_bzd_id} dsbzd_danhao={record.fy_bzd_danhao} yh_id={props.yh_id}  yh_name={props.yh_name} qy_id={props.qy_id} qy_name={props.qy_name}/>
            }
        },      
        {
            title: '开票',
            dataIndex: 'fy_fypdj_id',
            width: '5%',
            key: 'fy_fypdj_id',            
            render:(text) => text ? <span style={{color:'green'}}>已登记</span> : <span style={{color:'red'}}>未登记</span>
        },       
        {
            title: '状态',
            dataIndex: 'fy_state',
            width: '5%',
            key: 'fy_state',            
            render:(text) => <StateTag state={text} />
        },       
        {
            title: '编号',
            dataIndex: 'key',
            width: '5%',
            key: 'key',                        
        },       
    ]
    //多选
    //付款单id
    const [selectedfy_id, setSelectedfy_id] = useState([]);
    const [loading, setLoading] = useState(false);
    const start = () => {
        setLoading(true);
        // ajax request after empty completing
        setTimeout(() => {
            setSelectedfy_id([]);
            setLoading(false);
        }, 1000);
    };
    //开票金额
    const [selectedfy_amount, setSelectedfy_amount] = useState(0);
    const onSelectChange = (newSelectedRowKeys, selectedRows) => {

        // 如果本次是添加而不是取消选择，需要验证客户一致性
        if (newSelectedRowKeys.length > selectedfy_id.length) {
            // 新增的key
            const addedKey = newSelectedRowKeys.find(key => !selectedfy_id.includes(key));
            const addedRow = selectedRows.find(row => row.key === addedKey);
            // 找到当前已选首个的客户ID
            let commonKhId = undefined;
            if (selectedRows.length > 1) {
                // 当前已勾选的客户id
                // 通常 selectedRows 顺序和 newSelectedRowKeys 一致
                for (let row of selectedRows) {
                    if (row.key !== addedKey) {
                        commonKhId = row.fy_kh_id;
                        break;
                    }
                }
            }
            // 如果全部uncheck后再check，commonKhId也可能是undefined
            // 首次选取则允许
            if (commonKhId !== undefined && addedRow && addedRow.fy_kh_id !== commonKhId) {
                message.warning('只能选择同一个客户的付款单！');
                // 直接return，不更新
                return;
            }
        }
        setSelectedfy_amount(selectedRows.reduce((sum, row) => sum + Number(row.fy_amount || 0), 0));
        setSelectedfy_id(newSelectedRowKeys);
    }
    // 记录所选客户的id和name，传递下去
    const [selectedfy_kh_id, setSelectedfy_kh_id] = useState('');
    const [selectedfy_kh_name, setSelectedfy_kh_name] = useState('');

    useEffect(() => {
        // 根据已选的 selectedfy_id，查找客户id与name（如果有选中的付款单）
        if (selectedfy_id.length === 0) {
            setSelectedfy_kh_id('');
            setSelectedfy_kh_name('');
        } else {
            const selectedRow = list.find(item => item.key === selectedfy_id[0]);
            if (selectedRow) {
                setSelectedfy_kh_id(selectedRow.fy_kh_id || '');
                setSelectedfy_kh_name(selectedRow.fy_kh_name || '');
            }
        }
    }, [selectedfy_id, list]);
    const rowSelection = {
        selectedRowKeys: selectedfy_id,
        onChange: onSelectChange,
        getCheckboxProps: (record) => ({
            disabled: !!record.fy_fypdj_id, // ddsr_fypdj_id 有值不能选
        }),
    };
    const hasSelected = selectedfy_id.length > 0;
    return (
        <>                            
            <Flex style={{ marginBottom: "10px" }} align='center' justify='space-between'>
                <Form
                    layout='inline'
                    name='form_expense_invoice_expense_list'
                    form={form}
                    initialValues={{                        
                        fy_state: query.fy_state ? query.fy_state : '',                        
                    }}
                    onFinish={(values) => {
                        console.log(values);
                        // Serialize dayjs objects to strings before storing
                        const serializedValues = {
                            ...values,
                            
                            fy_kh_id: values.fy_kh_id ? values.fy_kh_id : '',
                        };
                        
                            localStorage.setItem('jtg-caiwu_incomeList_fy_kh_id', JSON.stringify(serializedValues.fy_kh_id));
                        setQuery(prev => ({ 
                            ...prev, 
                            dsbzd_state: serializedValues.dsbzd_state, 
                        }));
                    }}
                >
                    <ClientSelect
                        onChange={(value) => {
                            setQuery(prev => ({ 
                                ...prev, 
                                fy_kh_id: value,                                     
                            }));
                            localStorage.setItem('jtg-caiwu_incomeList_fy_kh_id', JSON.stringify(value));
                        }}
                        qy_id={props.qy_id}
                        qy_name={props.qy_name}
                        yh_id={props.yh_id}
                        yh_name={props.yh_name}
                        style={{width:'250px'}}
                        placeholder='选择费用客户'
                        name='fy_kh_id'
                    />                   
                    <Form.Item name='fy_fypdj_id'>
                        <Radio.Group
                            onChange={(e) => {
                               setQuery(prev => ({ 
                                ...prev, 
                                fy_fypdj_id: e.target.value,                                     
                                }));
                            }}
                        >
                            <Radio value='1'>全部</Radio>
                            <Radio value='2'>未登记</Radio>
                            <Radio value='3'>已登记</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item style={{marginLeft: 10}}>
                        <Space align='center' size='middle'>                           
                            <Icon type='reset'
                                onClick={() => {
                                    form.resetFields()
                                    localStorage.setItem('jtg-caiwu_incomeList_fy_kh_id', JSON.stringify(''))
                                    setQuery({
                                        "fy_kh_id": '',                                        
                                        "fy_fypdj_id": '1',
                                    })
                                    form.setFieldsValue({
                                        fy_kh_id: null,
                                        fy_fypdj_id: '1',
                                    });
                                }}
                            />
                        </Space>
                    </Form.Item>
                </Form> 
                <Flex align="center" gap="middle">
                    {hasSelected ? `已选择 ${selectedfy_id.length} 条费用单，总金额：￥${Number(selectedfy_amount).toLocaleString('zh-CN', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}` : ''}    
                        <ExpenseInvoiceAdd 
                            selectedfy_id={selectedfy_id}
                            qy_id={props.qy_id}
                            qy_name={props.qy_name}
                            yh_id={props.yh_id}
                            yh_name={props.yh_name}
                            selectedfy_amount={selectedfy_amount}
                            selectedfy_kh_id={selectedfy_kh_id}
                            selectedfy_kh_name={selectedfy_kh_name}
                        />                
                    <Icon 
                        type="reset" 
                        onClick={start} 
                        disabled={!hasSelected} 
                        loading={loading}
                    />
                </Flex> 
            </Flex>
            <Table 
                className={classes.orangeHeader}
                dataSource={list}
                columns={columns}
                pagination={false}
                size='small'
                bordered
                rowKey="key"
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.fy_amount || 0), 0);
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell key="summary-0" index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-1" index={1}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-2" index={2} colSpan={1}>
                                <span style={{color:'#3366FF'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-3" index={3} colSpan={columns.length - 2} />
                        </Table.Summary.Row>
                    );
                }}
                locale={{
                    emptyText: '暂无费用数据' // This will display text when the table is empty
                }}
                rowSelection={rowSelection}
            />
        </>
    )
}

export default ExpenseInvoiceExpenseList